import { render, staticRenderFns } from "./user-admin-component.vue?vue&type=template&id=de00d466&scoped=true&lang=pug"
import script from "./user-admin-component.js?vue&type=script&lang=js&external"
export * from "./user-admin-component.js?vue&type=script&lang=js&external"
import style0 from "./user-admin-component.vue?vue&type=style&index=0&id=de00d466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de00d466",
  null
  
)

export default component.exports